// Re-exported under these names for existing consumers — the values
// themselves live in `@aboutyou/ui-components` (as
// DESKTOP_STICKY_HEADER_HEIGHT / DESKTOP_ANCHOR_OFFSET_FROM_STICKY_HEADER)
// since ui-components sits below this package and other ui-components code
// (e.g. SkipLinks) needs them too. Imported from that specific file rather
// than the package's main barrel: pulling in the whole `ui-components`
// index re-exports its entire component tree into every consumer's
// TypeScript program, which surfaced as unrelated type errors in unrelated
// packages that transitively reach this file.
import {
  DESKTOP_ANCHOR_OFFSET_FROM_STICKY_HEADER,
  DESKTOP_STICKY_HEADER_HEIGHT,
  // eslint-disable-next-line monorepo/no-internal-import
} from '@aboutyou/ui-components/src/constants/heights';

export const ANCHOR_OFFSET_FROM_STICKY_HEADER =
  DESKTOP_ANCHOR_OFFSET_FROM_STICKY_HEADER;
export const DESKTOP_STICKY_HEIGHT = DESKTOP_STICKY_HEADER_HEIGHT;
export const SPACER_BEFORE_STICKY_HEADER = 20;
export const META_BAR_HEIGHT = 32;
export const NAVIGATION_HEIGHT = 52;
export const CAMPAIGN_BANNER_HEIGHT = 40;
export const USP_BANNER_HEIGHT = 40;
export const FLYOUT_CONTENT_MAX_HEIGHT_DESKTOP = 382;
export const SEARCH_BAR_WIDTH = 294;
export const SEARCH_BAR_FOCUSED_WIDTH = 433;
export const SEARCH_BAR_TABLET_WIDTH = 42;
export const SEARCH_BAR_HEIGHT = 36;
export const SEARCH_BAR_PINNED_TOP =
  (DESKTOP_STICKY_HEIGHT - SEARCH_BAR_HEIGHT) / 2;
export const SEARCH_BAR_OVERLAY_TOP_CSS_VAR = '--search-bar-overlay-top';
export const SLIDER_BUTTON_WIDTH = 32;
export const STREAM_TOP_SPACING = 32;
export const SEARCH_BAR_ANIMATION_TIME_MS = 200;
export const FLYOUT_CONTENT_PADDING = {
  bottom: 30,
  top: 30,
};

export const HEADER_DEFAULT_PADDING = {
  tablet: 20,
  desktop: 30,
  largeScreens: 60,
};
